import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";

interface TeamFilterProps {
  sortBy: string;
  onSortChange: (value: string) => void;
  filterRole: string;
  onFilterChange: (role: string) => void;
  roleCounts: Record<string, number>;
  totalMembers: number;
  enableFilter?: boolean;
}

const SORT_LABELS: Record<string, string> = {
  alphabetical_asc: "A-Z",
  alphabetical_desc: "Z-A",
  newest_first: "Newest",
  oldest_first: "Oldest",
};

export default function TeamFilter({
  sortBy,
  onSortChange,
  filterRole,
  onFilterChange,
  roleCounts,
  totalMembers,
  enableFilter = true,
}: TeamFilterProps) {
  return (
    <div className="flex min-w-[200px] flex-col gap-3">
      <div className="flex flex-col gap-1">
        <p className="text-sm leading-6 font-bold -tracking-wide text-neutral-800">
          Sort:
        </p>
        <Select onValueChange={onSortChange} value={sortBy}>
          <SelectTrigger className="!h-[45px] w-full bg-neutral-100 !px-5 !py-3 text-sm leading-normal font-medium text-neutral-800">
            <SelectValue>{SORT_LABELS[sortBy]}</SelectValue>
          </SelectTrigger>
          <SelectContent className="border-gray-300 bg-white !text-gray-700">
            <SelectItem value="alphabetical_asc" className="!text-gray-700">
              A-Z
            </SelectItem>
            <SelectItem value="alphabetical_desc" className="!text-gray-700">
              Z-A
            </SelectItem>
            <SelectItem value="newest_first" className="!text-gray-700">
              Newest
            </SelectItem>
            <SelectItem value="oldest_first" className="!text-gray-700">
              Oldest
            </SelectItem>
          </SelectContent>
        </Select>
      </div>
      {enableFilter && (
        <div className="flex flex-col gap-1">
          <p className="text-sm leading-6 font-bold -tracking-wide text-neutral-800">
            Filter:
          </p>
          <button
            onClick={() => onFilterChange("all")}
            className={cn(
              "hover:bg-brand-500/30 flex w-full cursor-pointer flex-row justify-between rounded-lg px-5 py-2 text-sm leading-normal font-medium text-neutral-800 transition-colors duration-200 ease-in-out",
              filterRole === "all" && "bg-brand-500 text-white",
            )}
          >
            <p>All</p>
            <p>{totalMembers}</p>
          </button>
          {Object.entries(roleCounts)
            .sort(([a], [b]) => a.localeCompare(b))
            .map(([role, count]) => (
              <button
                key={role}
                onClick={() => onFilterChange(role)}
                className={cn(
                  "hover:bg-brand-500/30 flex w-full cursor-pointer flex-row justify-between rounded-lg px-5 py-2 text-sm leading-normal font-medium text-gray-700 capitalize transition-colors duration-200 ease-in-out",
                  filterRole === role && "bg-brand-500 text-white",
                )}
              >
                <p>{role}</p>
                <p>{count}</p>
              </button>
            ))}
        </div>
      )}
    </div>
  );
}
